<template>
	<div class="publicBox billBox">
		<div class="main">
			<ul class="titleList flexBox">
				<li>发票申请详情</li>
			</ul>
		</div>
		<div class="flexBox desList">
			<div class="item card" style="width: 75rem;">
				<div class="title">开票信息</div>
				<ul class="list">
					<li class="flexBox">
						<div class="txt">发票抬头：</div>
						<div class="val">{{billDes.invoiceTitle}}</div>
					</li>
					<li class="flexBox">
						<div class="txt">纳税人识别码（税号）：</div>
						<div class="val">{{billDes.taxNumber}}</div>
					</li>
					<li class="flexBox">
						<div class="txt">发票金额：</div>
						<div class="val">{{billDes.invoiceAmount}}</div>
					</li>
					<li class="flexBox">
						<div class="txt">发票类型：</div>
						<div class="val">{{billDes.invoiceType}}</div>
					</li>
					<li class="flexBox">
						<div class="txt">电话：</div>
						<div class="val">{{billDes.comPhone}}</div>
					</li>
					<li class="flexBox">
						<div class="txt">地址：</div>
						<div class="val">{{billDes.address}}</div>
					</li>
					<li class="flexBox">
						<div class="txt">开户银行：</div>
						<div class="val">{{billDes.bankName}}</div>
					</li>
					<li class="flexBox">
						<div class="txt">银行账号：</div>
						<div class="val">{{billDes.bankAccount}}</div>
					</li>
				</ul>
			</div>
			<div class="item tell" style="width: 51rem;">
				<div class="title">联系信息</div>
				<ul class="list">
					<li class="flexBox">
						<div class="txt">联系人：</div>
						<div class="val">{{billDes.contactPerson}}</div>
					</li>
					<li class="flexBox">
						<div class="txt">电话：</div>
						<div class="val">{{billDes.contactPhone}}</div>
					</li>
					<li class="flexBox">
						<div class="txt">邮箱：</div>
						<div class="val">{{billDes.contactEmail}}</div>
					</li>
					<li class="flexBox">
						<div class="txt">备注：</div>
						<div class="val">{{billDes.remark}}</div>
					</li>
				</ul>
				<a-button class="btn" @click="clickBack">返回</a-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'BillDes',
		components: {},
		data() {
			return {
				billDes:{}
			}
		},
		mounted() {
			var id = this.$route.query.id;
			if(id != undefined){
				this.$reqToken("get", "/api/center/invoice/"+id,{}).then((res) => {
					this.billDes = res.data;
				})
			}
		},
		methods: {
			clickBack(){
				this.$router.push("/admin/bill")
			}
		}
	}
</script>

<style scoped>

</style>